import { ELLIPSIS_PLACEHOLDER } from '../types/constants';

export default function (text: string, query: string, maxLength: number) {
  const map: { [key: string]: string } = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  };

  text =
    text.length > maxLength ? text.substring(0, maxLength - ELLIPSIS_PLACEHOLDER.length) + ELLIPSIS_PLACEHOLDER : text;

  const escaped = text.replace(/[&<>"']/g, (m: string) => map[m]);

  if (!query) {
    return escaped;
  }

  const index = escaped.toLowerCase().indexOf(query.toLowerCase());
  if (index > -1) {
    const highlightEndIndex = index + query.length;

    return `${escaped.substring(0, index)}<mark class="marked">${escaped.substring(
      index,
      highlightEndIndex
    )}</mark>${escaped.substring(highlightEndIndex, highlightEndIndex + escaped.length)}`;
  } else {
    return escaped;
  }
}
